import {Cambridge_Mentor_ID, ECOACH_ID, IELTS_MENTOR_ID} from "@/core/option/typeCenterBill";

export const TYPE_CENTER = [
    {label: 'Nhãn E', value: 1 },
    {label: 'Đối tác', value: 0 }
];

export const CENTER_EDUTALK = [ECOACH_ID, IELTS_MENTOR_ID, Cambridge_Mentor_ID];